import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHerbMix = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M1.5,10.09v1a10.49,10.49,0,0,0,6.68,9.77V22.5h7.64V20.82a10.49,10.49,0,0,0,6.68-9.77v-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M10.09,10.09l7.8-7.8a2.7,2.7,0,0,1,3.82,3.82l-4,4"
		})
	]
});
const ForwardRef = forwardRef(SvgHerbMix);
export default ForwardRef;
